// use to generate the correct paath from contentful sale, 
// slug paramater must be included in the query
exports.getPathToSale = (sale) => {
    return `auctions/${sale?.slug || "untitled"}`
}